import { render, staticRenderFns } from "./TableResources.vue?vue&type=template&id=5fc3c2b2"
import script from "./TableResources.vue?vue&type=script&lang=js"
export * from "./TableResources.vue?vue&type=script&lang=js"
import style0 from "./TableResources.vue?vue&type=style&index=0&id=5fc3c2b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports